export const updateRunningDeliveryPlay = (data) => ({
  type: "UPDATE_RUNNING_DELIVERY_PLAY",
  payload: data,
});

export const updateRunningDeliveryFull = (data) => ({
  type: "UPDATE_RUNNING_DELIVERY_FULL",
  payload: data,
});
